module.exports = __webpack_public_path__ + "static/media/burrito_01_thumb_hover.aca731dd.png";